import { Input } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import React from "react";
type Props = {
  width?: string;
  placeholder?: string;
  leftSection?: React.ReactNode;
  onChange?: (value: string) => void;
  onSearch?: Function;
  defaultValue?: string;
  search?: any;
  value?: string;
};
const InputSearch = ({
  width,
  placeholder,
  onSearch,
  onChange,
  defaultValue,
  search,
  value,
}: Props) => {
  const onhandleFetchData = async () => {
    if (onSearch) {
      await onSearch();
    }
    if (search) {
      localStorage.setItem(
        "allValueKeySearch",
        JSON.stringify({ ...search, url: String(window.location.pathname) })
      );
    }
  };
  return (
    <Input
      w={width}
      placeholder={placeholder}
      type="text"
      value={value}
      defaultValue={defaultValue || value}
      leftSection={<IconSearch color="#15aabf" />}
      onKeyDown={async (e) => {
        if (e.key === "Enter") {
          onhandleFetchData();
        }
      }}
      onInput={(e: any) => {
        if (onChange) {
          onChange(e.target.value);
        }
      }}
    />
  );
};

export default InputSearch;
